import { Link } from 'react-router-dom';

export default function ArticleCTA() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20workspace%20with%20a%20laptop%20on%20a%20wooden%20desk%20displaying%20organized%20spreadsheet%20interface%2C%20surrounded%20by%20coffee%20cup%20notebook%20and%20soft%20textile%20accents%2C%20gentle%20golden%20hour%20light%20streaming%20through%20windows%20creating%20cozy%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20rich%20warm%20tones%20and%20organic%20textures%2C%20sophisticated%20yet%20approachable%20home%20office%20aesthetic%20with%20natural%20elements%20and%20thoughtful%20composition&width=1600&height=600&seq=cta-vigorbuy-v2&orientation=landscape"
          alt="VigorBuy Spreadsheet shopping guide"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 lg:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
          Ready to Master <strong className="font-heading font-normal text-primary-300">Spreadsheet Shopping</strong>?
        </h2>
        <p className="text-sm md:text-base text-white/75 max-w-lg mx-auto mb-8">
          Read our comprehensive VigorBuy Spreadsheet guide packed with expert tips, product discovery strategies, and shopping best practices
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer shadow-lg shadow-primary-500/20"
          >
            Read the Complete Guide <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}